import React from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'

import IconInstitutional from '../../assets/navIcon-institutional.svg'
import navStyles from './nav.module.scss'
import ShareBar from './shareBar'

class Nav extends React.Component {
  state = {
    menuOpen: false,
  }

  toggleMenu = forcedValue => {
    this.setState({
      menuOpen:
        forcedValue !== undefined && typeof forcedValue === 'boolean'
          ? forcedValue
          : !this.state.menuOpen,
    })
  }

  render() {
    const { article, belowFold } = this.props

    return (
      <nav
        role="navigation"
        className={`${navStyles.nav} ${
          belowFold ? navStyles.navBelowFold : ''
        }`}
        // onBlur={() => this.toggleMenu(false)}
      >
        <button
          className={`${navStyles.hamburger} ${navStyles.hamburgerSlider} ${
            this.state.menuOpen ? navStyles.active : ''
          }`}
          aria-label="Open the menu"
          onClick={this.toggleMenu}
        >
          <span className={navStyles.hamburgerBox} aria-hidden="true">
            <span className={navStyles.hamburgerInner}></span>
          </span>
        </button>

        <div
          className={`${navStyles.navContent} ${
            !this.state.menuOpen ? navStyles.navContent__hidden : ''
          }`}
        >
          <StaticQuery
            query={query}
            render={data => {
              const metadata = data.site.siteMetadata.articleMetadata

              return (
                <>
                  <h3 className={navStyles.h3}>{metadata.menuLabel}</h3>
                  <ul className={navStyles.ul}>
                    {data.allStrapiArticle.edges.map(itemObj => {
                      const item = itemObj.node
                      return (
                        <li key={item.id} className={navStyles.li}>
                          {/* {console.log(item.id, article.id)} */}
                          {item.id !== article.id ? (
                            <Link
                              to={`/${item.slug}`}
                              className={navStyles.link}
                            >
                              {item.num_chapter > 0
                                ? `${item.num_chapter}. `
                                : ''}
                              {item.short_title}
                            </Link>
                          ) : (
                            <span
                              className={`${navStyles.link} ${navStyles.current}`}
                            >
                              {item.num_chapter > 0
                                ? `${item.num_chapter}. `
                                : ''}
                              {item.short_title}
                            </span>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                  <footer className={navStyles.footer}>
                    <a
                      href="https://reporterbrasil.org.br/"
                      rel="noopener noreferrer"
                      target="_blank"
                      className={navStyles.link}
                    >
                      <IconInstitutional className={navStyles.icon} />
                      {metadata.menuInstitutional}
                    </a>
                    <ShareBar siteUrl={data.site.siteMetadata.siteUrl} />
                  </footer>
                </>
              )
            }}
          />
        </div>
      </nav>
    )
  }
}

export default Nav

const query = graphql`
  query {
    site {
      siteMetadata {
        siteUrl
        articleMetadata {
          menuLabel
          menuShare
          menuInstitutional
        }
      }
    }
    allStrapiArticle(
      sort: { fields: num_chapter, order: ASC }
      filter: { category: { name: { eq: "Published" } } }
    ) {
      edges {
        node {
          num_chapter
          id
          slug
          title
          short_title
        }
      }
    }
  }
`
